"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InitializationContext = void 0;
var InitializationContext = /** @class */ (function () {
    function InitializationContext(newDocument) {
        this.newDocument = false;
        this.tasks = new Set();
        this.waiting = [];
        this.newDocument = newDocument;
    }
    /**
     * Prevents any waiting callbacks from being executed before the specified action completes.
     * @returns The return value of `action`.
     */
    InitializationContext.prototype.execute = function (action) {
        // create a promise which will never actually be resolved, but it will prevent the waiting queue from being processed
        var marker = new Promise(function () { });
        this.tasks.add(marker);
        var result = action();
        this.tasks.delete(marker);
        this.processWaitingQueue();
        return result;
    };
    InitializationContext.prototype.wait = function (task) {
        var _this = this;
        this.tasks.add(task);
        task.then(function () {
            // process the queue asynchronously to allow additional tasks to be queued as a result of this one
            Promise.resolve().then(function () {
                _this.tasks.delete(task);
                _this.processWaitingQueue();
            });
        });
    };
    Object.defineProperty(InitializationContext.prototype, "canProcessQueue", {
        get: function () {
            return this.tasks.size === 0;
        },
        enumerable: false,
        configurable: true
    });
    InitializationContext.prototype.processWaitingQueue = function () {
        if (this.canProcessQueue) {
            while (this.waiting.length > 0 && this.canProcessQueue) {
                var done = this.waiting.shift();
                done();
            }
        }
    };
    InitializationContext.prototype.whenReady = function (callback) {
        if (this.canProcessQueue)
            callback();
        else
            this.waiting.push(callback);
    };
    InitializationContext.prototype.tryResolveValue = function (instance, property, value) {
        var task = instance.serializer.resolveValue(instance, property, value);
        if (task)
            this.wait(task);
        return task;
    };
    Object.defineProperty(InitializationContext.prototype, "isNewDocument", {
        get: function () {
            return this.newDocument;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InitializationContext.prototype, "ready", {
        get: function () {
            var _this = this;
            return new Promise(function (resolve) { return _this.whenReady(resolve); });
        },
        enumerable: false,
        configurable: true
    });
    return InitializationContext;
}());
exports.InitializationContext = InitializationContext;
